import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
// import { quill } from 'quill';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html'
})
export class EditorComponent implements OnInit {
  editorform: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.editorform = this.fb.group({
      test: ['', '']
    });
  }

}
